<template>
    <section class="our-projects" :id="$t('routes.work')" :ref="$t('routes.work')">

  <div class="sloth-container">
    <h2 class="section-title text-center">
      {{ title }}
    </h2>

    <div class="projects-sloth">  
      <WorkItem v-for="(work, key) in works" :key="key"
        :title="work.title" 
        :image="work.image" 
        :services="work.services" 
        :description="work.description"/>
    </div>
  </div>

</section>
</template>

<script>
import WorkItem from "../items/WorkItem";

export default {
  name: "OurWork",
  components: {
    WorkItem
  },
  props: {
    works: Array
  }
};
</script>